import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(31 29)">
      <g fill="#51565c" fillRule="nonzero">
        <path d="m78.8110903 56.619313-21.3396979 17.9061327-2.2497567-2.6811555 21.1976055-17.7869029-15.5071081-2.1733453.3648477-3.4458348 19.4595523 2.7272864c.8765623.1228516 1.5394237.8853864 1.5390858 1.7705157l-.0075016 19.6497382-3.4630772-.1182705z" />
        <path d="m34.935205 14.1455703-21.3410871 17.9072983-2.2497567-2.6811555 21.1566294-17.7525199-15.3809885-2.43009043.4249302-3.43894257 19.4089908 3.06648705c.8742848.13813097 1.5237372.9121182 1.5079517 1.79710675l-.3504357 19.6466145-3.4604857-.1786915z" />
        <path d="m83.8110903 8.44438722-21.3396979 17.90613268-2.2497567-2.6811555 21.1976055-17.78690293-15.5071081-2.17334523.3648477-3.44583485 19.4595523 2.72728641c.8765623.12285156 1.5394237.88538641 1.5390858 1.77051567l-.0075016 19.64973823-3.4630772-.1182705z" />
      </g>
      <path d="m0 47h18v18h-18z" fill="#53a2d9" />
      <path d="m31 41h18v18h-18z" fill="#7bb835" />
      <path d="m25 74h18v18h-18z" fill="#15539f" />
    </g>
  </Svg>
)
